// Generate Schema.org structured data for SEO

export const generateLocalBusinessSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "GeneralContractor",
    "@id": "https://cthomeremodels.com/#organization",
    "name": "Visser General Construction LLC",
    "alternateName": "CTHomeRemodels.com",
    "url": "https://cthomeremodels.com",
    "logo": "https://cthomeremodels.com/api/media/name/visser-general-construction-llc-logo-connecticut.png",
    "image": "https://cthomeremodels.com/api/media/name/visser-general-construction-llc-logo-connecticut.png",
    "description": "Quality home remodeling and construction services in Connecticut. Kitchen remodels, bathroom renovations, decking, basements, siding, and more.",
    "telephone": "+1-203-604-3202",
    "email": "codyvisser5@gmail.com",
    "priceRange": "$$",
    "foundingDate": "2022",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "42 Gay St",
      "addressLocality": "Meriden",
      "addressRegion": "CT",
      "postalCode": "06450",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.5382",
      "longitude": "-72.8071"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Meriden",
        "containedIn": {
          "@type": "State",
          "name": "Connecticut"
        }
      },
      {
        "@type": "City",
        "name": "Wallingford",
        "containedIn": {
          "@type": "State",
          "name": "Connecticut"
        }
      },
      {
        "@type": "City",
        "name": "Old Saybrook",
        "containedIn": {
          "@type": "State",
          "name": "Connecticut"
        }
      },
      {
        "@type": "City",
        "name": "Madison",
        "containedIn": {
          "@type": "State",
          "name": "Connecticut"
        }
      },
      {
        "@type": "City",
        "name": "Guilford",
        "containedIn": {
          "@type": "State",
          "name": "Connecticut"
        }
      }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "05:00",
        "closes": "17:30"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/codyvisser",
      "https://www.google.com/maps/place/Visser+General+Construction"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Construction Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Kitchen Remodeling",
            "description": "Custom kitchen remodeling with modern designs"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Bathroom Remodeling",
            "description": "Complete bathroom renovations"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Deck Building",
            "description": "Trex composite decking installation"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Basement Finishing",
            "description": "Transform basements into living spaces"
          }
        }
      ]
    }
  };
};

export const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

export const generateServiceSchema = (service, city = null) => {
  const baseUrl = 'https://cthomeremodels.com';
  const locationSuffix = city ? ` in ${city}, CT` : ' in Connecticut';
  
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": service.title + locationSuffix,
    "provider": {
      "@type": "GeneralContractor",
      "name": "Visser General Construction LLC",
      "url": baseUrl,
      "telephone": "+1-203-604-3202"
    },
    "areaServed": {
      "@type": city ? "City" : "State",
      "name": city || "Connecticut"
    },
    "description": service.description
  };
};

export const generateAggregateRatingSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": "27"
    }
  };
};